const MANUAL_DNS_STAGES = ['staging', 'prod'];
export function isManualDnsStage(stage) {
    return MANUAL_DNS_STAGES.includes(stage);
}
